import device_information from '@devices/settings/device_settings/device_information';
import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'ShellyBLURCButton4ZB',
	friendly_name: 'BLU RC Button 4 ZB',
	family: 'inputs_reader',
	isPM: false,
	modes: {
		inputs_reader: {
			channels: 4,
			notifications: ['device_problem', 'lowBattery'],
			bluetooth_settings: [
				{ title: 'beacon_mode', component: 'beacon_ble' },
				{ title: 'zigbee', component: 'zigbee_ble', min_ver: '1.2.12' },
				{ title: 'security', component: 'security_ble' },
			],
			settings: [
				{
					title: 'application_settings',
					components: [{ title: 'exclude_event_log', component: 'exclude_event_log' }],
				},
				share,
				{
					title: 'settings',
					components: [
						{ title: 'firmware_update', component: 'firmware_update_ble' },
						{ title: 'factory_reset', component: 'factory_reset_ble' },
					],
				},
				device_information,
			],
		},
	},
};
